import {mapState} from 'vuex'
import storageUtils from '../../util/storageUtils'
import io from 'socket.io-client'
import Axios from 'axios'
import {debounce} from 'throttle-debounce'

export default {
  data () {
    return {
      isActive: true,
      socket: null,
      reader: {
        fetching: false
      }
    }
  },
  computed: mapState({
    idCardConfigure: state => state.configure.idCard
  }),
  methods: {
    createSocket (port) {
      this.closeSocket()
      this.socket = {
        connected: false,
        prompted: false,
        error: null
      }
      let client = this.socket.client =
        io.connect(`http://localhost:${port}`, {
          'timeout': 300000,
          'reconnectionDelayMax': 1000,
          'reconnectionDelay': 500,
          cors: {
            origin: '*'
          }
        })
      client.on('connect', () => {
        console.log('connect')
        if (this.socket) {
          this.socket.connected = true
        }
        client.emit('startRead')
      })
      client.on('disconnect', () => {
        this.socket.connected = false
        this.socket.error = null
      })
      client.on('card message', (msg) => {
        console.log('card message', msg)
        let result = this.$base64.decode(msg)
        this.receiveIdCard(JSON.parse(result))
        console.log('card message', result)
      })
      client.on('error message', (msg) => {
        if (this.socket) {
          this.socket.error = msg
          this.socketErrCleaner()
          if (!this.socket.prompted) {
            this.socket.prompted = true
            this.$notify.error({
              title: '提示',
              message: '身份证读取连接异常'
            })
          }
        }
      })
    },
    closeSocket () {
      if (this.socket) {
        let client = this.socket.client
        if (client) {
          client.disconnect()
        }
        this.socket = null
      }
    },
    configureReader () {
      const idCardConfigure = this.idCardConfigure
      switch (idCardConfigure.readType) {
        case 'auto': {
          this.createSocket(idCardConfigure.socketPort)
          break
        }
        case 'manual': {
          this.closeSocket()
          break
        }
        default:
          break
      }
    },
    fetchIdCard () {
      console.log('fetchIdCard')
      const idCardConfigure = this.idCardConfigure
      if (idCardConfigure) {
        let {secure, httpPort, httpsPort} = idCardConfigure
        let url = `${secure ? 'https' : 'http'}://localhost:${secure ? httpsPort : httpPort}/api/ReadMsg`
        this.reader.fetching = true
        Axios.get(url).then(response => {
          let data = response.data
          console.log(response)
          if (data) {
            if (data.code === '0') {
              let retCode = (data.retcode || '').split(' ')
              if (retCode[0] === '0x90') {
                this.receiveIdCard(response.data)
              } else {
                this.$message.warning(data.retmsg || '读取失败')
              }
            } else {
              this.$message.warning(data.errmsg || data.retmsg || '读取返回信息异常')
            }
          }
        }, () => {
          this.$message.error('身份证读取请求发送失败')
        }).finally(() => {
          this.reader.fetching = false
        })
      }
    },
    receiveIdCard (idCard) {
      if (this.isActive) {
        this.$emit('receive-card', idCard)
      }
    }
  },
  created () {
    this.socketErrCleaner = debounce(2000, () => {
      if (this.socket && this.socket.error) {
        let client = this.socket.client
        if (client) {
          client.emit('isReading', '', (data) => {
            if (data) {
              this.socket.error = null
              this.socket.prompted = false
              this.$notify.success({
                title: '提示',
                message: '身份证读取连接成功'
              })
            }
          })
        }
      }
    })
  },
  mounted () {
    this.configureReader()
  },
  beforeDestroy () {
    this.closeSocket()
  },
  activated () {
    this.isActive = true
  },
  deactivated () {
    this.isActive = false
  },
  watch: {
    'idCardConfigure': {
      handler: function (val) {
        storageUtils.setItem('id-card', 'configure', val)
      },
      deep: true
    },
    'idCardConfigure.readType': function () {
      this.configureReader()
    },
    'idCardConfigure.socketPort': function () {
      this.configureReader()
    }
  }
}
